import { render, staticRenderFns } from "./notification-alert.vue?vue&type=template&id=88bd7070"
import script from "./notification-alert.vue?vue&type=script&lang=js"
export * from "./notification-alert.vue?vue&type=script&lang=js"
import style0 from "./notification-alert.vue?vue&type=style&index=0&id=88bd7070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports